import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { fadeInOut } from '../../../../shared/helpers/animations';
import { ILLGenericKeys, ILLProduct } from '../../../../shared/models';
import { ILLFormDetail } from '../../../../shared/models/ll-form-detail.model';
import { LLFormService, StorageManagerService } from '../../../../shared/services';
import { Utilities } from '../../../../shared/services/utilities';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';

@Component({
    selector: 'app-ll-form-product-information',
    templateUrl: './ll-form-product-information.component.html',
    styleUrls: ['./ll-form-product-information.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class LLFormProductInformationComponent implements OnInit, OnChanges {

    ndcProductCodeChangedObject = {};
    newProduct = false;

    constructor (
        private fb: UntypedFormBuilder, private llFormService: LLFormService,
        public datepipe: DatePipe, private utilService: Utilities, private storage: StorageManagerService) {
    }

    @ViewChild('productType') public productType: LLFormProductInformationComponent;
    @ViewChild('testForm') public testFormElement;

    @ViewChild('confirmDialog')
    public confirmDialog: DialogComponent;

    // dialog settings
    isModal: Boolean = true;
    animationSettings: Object = { effect: 'Zoom' };
    hide: any;
    position: object = { X: 'center', Y: 'center' };
    target = '#modalTarget';
    visible: Boolean = true;
    hidden: Boolean = false;
    modalWidth = '450px';

    @Input() revisionId: string;
    @Input() llFormData: ILLFormDetail;
    @Input() prodIndex: number;
    @Input() partIndex: number;
    @Input() isPart: boolean;
    @Input() titleText: string;
    @Input() ndcLabelerCode: string;
    @Input() productId: number;
    @Input() ndcProductCodeInput: any;
    @Input() bIsKit: boolean;

    @Output() ndcProductCode = new EventEmitter<any>();

    public frmProductInformation: UntypedFormGroup;
    dataProductDetail: ILLProduct = new ILLProduct();
    frmDetailData: ILLFormDetail = new ILLFormDetail();
    productTypes: ILLGenericKeys[];
    deaSchedule: ILLGenericKeys[];
    routeAdmin: ILLGenericKeys[];
    errorMessage: string;
    submitted = false;
    loading = false;
    labelerCode: string;
    canDisplayCertificationStatus: boolean = false;
    productTypesLOV: ILLGenericKeys[];
    deaScheduleLOV: ILLGenericKeys[];
    routeAdminLOV: ILLGenericKeys[];
    allLOV: any[];
    selectedProductTypes: string[];
    inactiveROAsList: any[] = [];
    public ddwHeight = '220px';
    // maps the appropriate column to fields property
    public ddwFields: Object = { text: 'labelAndCode', value: 'id' };
    public prodTypesWaterMark = 'Select Product Type';
    public deaScheduleWaterMark = 'Select DEA Schedule';
    public RouteAdminWaterMark = 'Select Route of Administration';

    newFormObject: Object = {};

    confirmDlgBtnClickYes: EmitType<object> = () => {
        this.confirmDialog.hide();
        this.ndcProductCode.emit(this.ndcProductCodeChangedObject);
    }


    confirmDlgBtnClickNo: EmitType<object> = () => {

        this.confirmDialog.hide();
        this.frmProductInformation.patchValue({
            itemCode: this.ndcProductCodeChangedObject['oldNdcCode']
        });
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    confirmDlgButtons: Object[] = [{ click: this.confirmDlgBtnClickNo.bind(this), buttonModel: { content: 'Cancel' } }, { click: this.confirmDlgBtnClickYes.bind(this), buttonModel: { content: 'Continue', isPrimary: true } }];

    ngOnInit(): void {
        this.frmProductInformation = this.fb.group({
            drpProductTypes: [''],
            drpRouteAdmin: [''],
            drpDeaSchedule: [''],
            labelerCode: [''],
            itemCode: [''],
            srcNDC1: [''],
            srcNDC2: [''],
            hiddenProductType: ['']
        });

        // retrieve data and populate controls on the component
        this.loadData();

        // Watches changes on the entire form
        this.frmProductInformation.valueChanges.subscribe(data => {
            this.llFormService.llFormProductInformationSubject.next(this.frmProductInformation.value);
        });

        this.llFormService.llFormProductInformationSubject.next(this.frmProductInformation.value);
    }

    // Populate pre-saved data
    loadData() {
        if (this.frmProductInformation) {
            this.frmProductInformation.reset();
            if (this.llFormData) {
                if (this.llFormData[1] && this.llFormData[1]['data']) {
                    this.allLOV = this.llFormData[1]['data'];
                    this.productTypesLOV = this.getLOVDataByTypeForLL('doc_type', 'doc_type_ll', true);
                    this.deaScheduleLOV = this.getLOVDataByType('dea', true);
                    this.routeAdminLOV = this.getLOVDataByType('roa', false);
                }

                if (this.llFormData[0] && this.llFormData[0]['data']) {
                    this.frmDetailData = this.llFormData[0]['data'];

                    if (this.frmDetailData) {
                        this.dataProductDetail = this.llFormData[0]['data']['products'][this.prodIndex];
                        if ((this.partIndex || this.partIndex === 0) && this.llFormData[0]['data']['products'][this.prodIndex]['parts']) {
                            this.dataProductDetail = this.llFormData[0]['data']['products'][this.prodIndex]['parts'][this.partIndex];
                        }
                        if (this.dataProductDetail && !this.dataProductDetail.productId && (!this.partIndex && this.partIndex !== 0)) {
                            this.newProduct = true;
                        }

                        this.populateControls();
                    }
                }
            }
        }
    }

    onOverlayClick: EmitType<object> = () => {
        this.confirmDialog.hide();
    }


    // Get a list of LOVs by doc_type, created a new column that will
    // concatenate label and code fields for displaying purpose
    getLOVDataByType(type: string, bCreateEmptyItem: boolean): any[] {
        const emptySelectItem = {};
        const dataLOV = this.allLOV.filter(x => x.vocaB_TYPE === type);
        const newLOV = dataLOV.map(item => {
            const container = {};
            container['id'] = item['id'];
            container['code'] = item['code'];
            container['labelAndCode'] = item['label'] + ' (' + item['code'] + ')';
            return container;
        });

        // Add an empty selection
        if (newLOV && bCreateEmptyItem) {
            emptySelectItem['labelAndCode'] = '';
            emptySelectItem['code'] = '';
            emptySelectItem['id'] = 0;
            newLOV.splice(0, 0, emptySelectItem);
        }
        return newLOV;
    }

    // Get a list of LOVs by doc_type, created a new column that will
    // concatenate label and code fields for displaying purpose
    getLOVDataByTypeForLL(DisplayType: string, formType: string, bCreateEmptyItem: boolean): any[] {
        const emptySelectItem = {};
        let dataLOV = this.allLOV.filter(x => x.vocaB_TYPE === DisplayType && x.lsP_FORM_TYPE === formType);
        const newLOV = dataLOV.map(item => {
            const container = {};
            container['id'] = item['id'];
            container['code'] = item['code'];
            container['labelAndCode'] = item['label'] + ' (' + item['code'] + ')';
            return container;
        });

        // Add an empty selection
        if (newLOV && bCreateEmptyItem) {
            emptySelectItem['labelAndCode'] = '';
            emptySelectItem['code'] = '';
            emptySelectItem['id'] = 0;
            newLOV.splice(0, 0, emptySelectItem);
        }

        return newLOV;
    }

    // Populate Product Information Section
    populateControls() {
        if (this.dataProductDetail) {
            if (!this.newProduct) {
                const codes = [];
                let ndcProductCode = ''
                if (this.dataProductDetail.ndcProductCode) {
                    const codes = this.dataProductDetail.ndcProductCode.split('-');
                    ndcProductCode = codes.length > 1 && codes[1] && codes[1] !== 'null' ? codes[1].replace('xxxx', '') : '';
                }

                if (!ndcProductCode) {
                    ndcProductCode = this.getNdcProductCode();
                }
                this.frmProductInformation.patchValue({
                    itemCode: ndcProductCode
                });


                if (this.frmDetailData) {
                    this.frmProductInformation.patchValue({
                        labelerCode: this.isPart ? (this.dataProductDetail.ndcProductCode ? this.dataProductDetail.ndcProductCode.split('-')[0] : '') : this.frmDetailData.ndcLabelerCode
                    });
                }

                if (this.dataProductDetail.sourceNDCCode) {
                    const codes = this.dataProductDetail.sourceNDCCode.split('-');
                    this.frmProductInformation.patchValue({
                        srcNDC1: codes[0],
                        srcNDC2: codes[1]
                    });
                }

                this.frmProductInformation.patchValue({
                    drpRouteAdmin: this.dataProductDetail.routeOfAdmins ? this.getSavedMultiSelectIds(this.dataProductDetail.routeOfAdmins) : [],
                    drpDeaSchedule: this.dataProductDetail.deaSchedule ? +this.dataProductDetail.deaSchedule.id : null,
                    hiddenProductType: this.partIndex || this.partIndex === 0 ? 'Part' : ''
                });
            }

            // setting service type applies for either new or existing product
            if (this.frmDetailData.setId) {
                this.labelerCode = this.isPart ? (this.dataProductDetail.ndcProductCode ? this.dataProductDetail.ndcProductCode.split('-')[0] : '') : this.frmDetailData.ndcLabelerCode;
                this.frmProductInformation.patchValue({
                    drpProductTypes: +this.frmDetailData.serviceType.id
                });
                // Don't display cert statuses if the product type is not supported or if it's a kit part
                this.canDisplayCertificationStatus = this.dataProductDetail.listingRecordCertifiedThroughStatus !== 'Not Supported' && !(this.bIsKit && this.isPart);
            }
        }
    }

    // Get ndc product code for the product
    getNdcProductCode() {
        let ndcProductCode = '';

        // if this is part and ndcProductCode is null, get the ndcProductCode from packaging section if it exists there
        // by looping through all the  package configurations and packages inside each configuaration until we found a valid ndcProductCode
        if (this.isPart && !ndcProductCode && this.dataProductDetail) {
            for (let i = 0; i < this.dataProductDetail.packageConfigurations.length; i++) {
                for (let j = 0; j < this.dataProductDetail.packageConfigurations[i].packages.length; j++) {
                    const singlePackage = this.dataProductDetail.packageConfigurations[i].packages[j];

                    if (singlePackage.code) {
                        const packageCode = singlePackage.code.split('-');
                        if (packageCode && packageCode.length > 1 && packageCode[1]) {
                            ndcProductCode = packageCode[1];
                            break;
                        }
                    }
                }
                if (ndcProductCode) {
                    break;
                }
            }
        }

        return ndcProductCode;
    }

    // when form data changed from the parent, refresh the component
    ngOnChanges(changes: SimpleChanges) {
        // eslint-disable-next-line guard-for-in
        for (const property in changes) {
            if (property === 'llFormData' || property === 'prodIndex' || property === 'partIndex' || property === 'productId') {
                this.loadData();
            }

            // should allow empty space
            if (property === 'ndcLabelerCode' && changes[property].currentValue !== undefined && this.frmProductInformation) {
                this.labelerCode = this.ndcLabelerCode;

                this.frmProductInformation.patchValue({
                    labelerCode: this.labelerCode
                });
            }
            // should allow empty space
            if (property === 'ndcProductCodeInput' && changes[property].currentValue !== undefined && this.frmProductInformation) {

                this.frmProductInformation.patchValue({
                    itemCode: changes[property].currentValue
                });
            }
        }
    }

    ddwChanged(event) {
        this.frmProductInformation.markAsDirty();
    }

    // Get a list previously saved Ids from the multi-select dropdown control
    getSavedMultiSelectIds(data: ILLGenericKeys[]): number[] {
        let arrIds = [];
        this.dataProductDetail.routeOfAdmins.forEach(element => {
            // if ID existed, add to the list
            if (element.id && element.id !== '0') {
                arrIds.push(+element.id);
            } else {
                // If ROA id does not exist, try to match with ROA description
                // if still can not find a match, display a warning messaage to the user
                const newUOMValue = this.llFormService.checkForLOVSelection(this.routeAdminLOV, element.id, element.label);
                if (newUOMValue[0] && newUOMValue[0] !== '0') {
                    arrIds.push(+newUOMValue[0]);
                } else if (newUOMValue[2]) {
                    this.inactiveROAsList.push(newUOMValue[2]);
                }
            }
        });

        const uniquIds = arrIds.filter(x => x !== 0);
        return uniquIds;
    }

    ndcProductCodeChanged(event) {

        if (!this.isPart) {

            const oldNdcCode = this.dataProductDetail.ndcProductCode.split('-')[1] ? this.dataProductDetail.ndcProductCode.split('-')[1] : '';

            this.ndcProductCodeChangedObject['newNdcCode'] = event.target.value;
            this.ndcProductCodeChangedObject['oldNdcCode'] = oldNdcCode;

            if (oldNdcCode) {

                if (event.target.value !== oldNdcCode) {
                    this.frmProductInformation.markAsDirty();

                  // Suppress popup when NDC Product Code is entered for the first time
                  if (oldNdcCode === 'xxxx') {
                        this.ndcProductCode.emit(this.ndcProductCodeChangedObject);
                    } else {
                        this.confirmDialog.show();
                    }
                }

            } else {
                if (event.target.value !== oldNdcCode) {
                    this.frmProductInformation.markAsDirty();
                    this.ndcProductCode.emit(this.ndcProductCodeChangedObject);
                }
            }
        } else {

            this.ndcProductCodeChangedObject['newNdcCode'] = event.target.value;

            if (this.dataProductDetail.ndcProductCode) {
                this.ndcProductCodeChangedObject['oldNdcCode'] = this.dataProductDetail.ndcProductCode.split('-')[1] ? this.dataProductDetail.ndcProductCode.split('-')[1] : '';
            }

            this.ndcProductCode.emit(this.ndcProductCodeChangedObject);
            this.frmProductInformation.markAsDirty();
        }
    }
}
